export enum CalculationViewSidebarVariants {
  Car = 'car',
  Travel = 'travel',
}
